import { Type } from 'class-transformer';
import { ARInvoiceItemResultDto } from './ar-invoice-item-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';

export class ARInvoiceResultDto {
    title: string;
    customerCode: string;
    customerId: number;
    documentNumber: string;
    documentType: string;
    name: string;
    @Type(() => Date)
    documentDate: Date;
    @Type(() => Date)
    postDate: Date;
    @Type(() => Date)
    dueDate: Date;
    charge: number;
    chargeDue: number;
    description: string;
    @Type(() => UpdatedResultDto)
    lastUpdate: UpdatedResultDto;
    @Type(() => FileInfoDisplayResultDto)
    supportDocument: FileInfoDisplayResultDto;
    subLedger: string;

    @Type(() => ARInvoiceItemResultDto)
    items: Array<ARInvoiceItemResultDto>;
    @Type(() => KeyValueResultDto)
    requiredDimensions: Array<KeyValueResultDto>;
    allowReverse = false;
    allowWaive = false;
    allowWriteOff = false;
    allowDelete = false;

    allowEdit = false;

    /**
     * If allow Edit is false, allowBasicEdit is true, then user can only modify
     */
    allowBasicEdit = false;

    allowDuplicate = false;
    allowApplyCredit = false;
    @Type(() => Date)
    reversedDate: Date;
    isWrittenOff = false;
    isWaived = false;
    isReversalInvoice = false;
    relatingARAdjustmentID: number;
    relatingARAdjustmentNumber: string;
    @Type(() => Date)
    deletedDate: Date;
    @Type(() => FileInfoDisplayResultDto)
    attachments: FileInfoDisplayResultDto[];
    invoiceType: string;
    hasCreditApplications: boolean;

    isSuccessMessage: boolean;
    message: string;
}
